import crypto from 'crypto';

export const Signature = (input_string) => {
    const  apiKey = 'AIzaSyDDO-gu5fj6WLJq-mZj0mrzh0HFnMSnbhA';
    const hmac = crypto.createHmac('sha256', apiKey);
    hmac.write(input_string);
    return hmac.digest('base64');
}